import React from 'react';
import { Navigate } from 'react-router-dom';
import PostsService from '../services/PostsService';

const ProtectedRoute = ({ children }) => {
  if (!PostsService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute; 